var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeydriveLogoAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 18,
    viewBox: "0 0 130 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_195",
    "data-name": "Caminho 195",
    d: "M75.4,10.077H86.953V15.31H84.347V12.69H75.395a3.907,3.907,0,1,1,0-2.627h0Zm-3.66.021a1.286,1.286,0,1,0,1.279,1.286A1.281,1.281,0,0,0,71.741,10.1Z",
    transform: "translate(-67.85 -7.47)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1",
    transform: "translate(0 0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_604",
    "data-name": "Grupo 604",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_601",
    "data-name": "Grupo 601",
    transform: "translate(56.595 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_131",
    "data-name": "Caminho 131",
    d: "M98.545,5.676a8.362,8.362,0,0,0-1.857-2.812A8.66,8.66,0,0,0,93.8,1.01,10.132,10.132,0,0,0,90.047.34H83.19V6.155h4.123V3.508h2.735a5.206,5.206,0,0,1,2.1.4A4.317,4.317,0,0,1,93.7,5.04a5.068,5.068,0,0,1,.973,1.8,7.81,7.81,0,0,1,.34,2.374,7.9,7.9,0,0,1-.34,2.388,5.128,5.128,0,0,1-.973,1.8,4.26,4.26,0,0,1-1.558,1.136,5.206,5.206,0,0,1-2.1.4H87.313V12.018H83.19V18.1h6.858a10.106,10.106,0,0,0,3.748-.664,8.452,8.452,0,0,0,2.891-1.854,8.229,8.229,0,0,0,1.857-2.812A9.289,9.289,0,0,0,99.2,9.22a9.219,9.219,0,0,0-.66-3.537Z",
    transform: "translate(-83.19 -0.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_132",
    "data-name": "Caminho 132",
    d: "M125.8,18.1H122.1a1.568,1.568,0,0,1-1.476-.78l-2.932-5.152a1.357,1.357,0,0,0-.463-.479,1.428,1.428,0,0,0-.728-.151h-1.041V18.1h-4.1V.35H117.1a11.591,11.591,0,0,1,3.265.4,6.18,6.18,0,0,1,2.2,1.1,4.222,4.222,0,0,1,1.245,1.669,5.561,5.561,0,0,1,.388,2.093,5.587,5.587,0,0,1-.231,1.635,5.037,5.037,0,0,1-.68,1.416,5.11,5.11,0,0,1-1.109,1.163,5.917,5.917,0,0,1-1.517.842,3.423,3.423,0,0,1,.748.52,3.75,3.75,0,0,1,.633.739L125.8,18.1ZM117.1,8.69a4.128,4.128,0,0,0,1.422-.212,2.658,2.658,0,0,0,.966-.588,2.285,2.285,0,0,0,.544-.883,3.313,3.313,0,0,0,.17-1.088,2.293,2.293,0,0,0-.755-1.827,3.515,3.515,0,0,0-2.347-.657h-1.646V8.7H117.1Z",
    transform: "translate(-92.196 -0.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_133",
    "data-name": "Caminho 133",
    d: "M139.819,18.1h-4.13V.35h4.13V18.1Z",
    transform: "translate(-99.974 -0.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_134",
    "data-name": "Caminho 134",
    d: "M162.878.35,155.8,18.1H152.1L145.02.35h3.293A1.387,1.387,0,0,1,149.17.6a1.605,1.605,0,0,1,.5.643l3.415,9.5c.163.417.32.869.469,1.361s.3,1.006.435,1.539c.116-.534.238-1.047.381-1.539s.293-.944.456-1.361l3.395-9.5a1.484,1.484,0,0,1,.476-.616,1.328,1.328,0,0,1,.857-.274h3.32Z",
    transform: "translate(-102.957 -0.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_135",
    "data-name": "Caminho 135",
    d: "M178.506,3.518V7.664h5.551v3.044h-5.551v4.228h7.245V18.1H174.39V.35h11.361V3.518Z",
    transform: "translate(-112.346 -0.343)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_602",
    "data-name": "Grupo 602",
    transform: "translate(46.159 5.117)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_136",
    "data-name": "Caminho 136",
    d: "M75.392,11.4l-.122-.089h.122Z",
    transform: "translate(-70.222 -8.683)",
    fill: "#f99601",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_137",
    "data-name": "Caminho 137",
    d: "M75.137,11.782l-.667-.472h.544l.122.089Z",
    transform: "translate(-69.966 -8.683)",
    fill: "#f99501",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_138",
    "data-name": "Caminho 138",
    d: "M74.884,12.165l-1.2-.855h.537l.667.472Z",
    transform: "translate(-69.714 -8.683)",
    fill: "#f89401",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_139",
    "data-name": "Caminho 139",
    d: "M74.628,12.541,72.88,11.31h.544l1.2.855Z",
    transform: "translate(-69.458 -8.683)",
    fill: "#f89301",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_140",
    "data-name": "Caminho 140",
    d: "M74.373,12.925,72.08,11.31h.544l1.748,1.231Z",
    transform: "translate(-69.202 -8.683)",
    fill: "#f89201",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_141",
    "data-name": "Caminho 141",
    d: "M74.248,13.308l-2.558-1.8v-.2h.265l2.293,1.615Z",
    transform: "translate(-69.078 -8.683)",
    fill: "#f89101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_142",
    "data-name": "Caminho 142",
    d: "M74.248,13.782,71.69,11.976V11.6l2.558,1.8Z",
    transform: "translate(-69.078 -8.774)",
    fill: "#f89001",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_143",
    "data-name": "Caminho 143",
    d: "M73.989,14.148l-2.3-1.615V12.15l2.558,1.806v.192Z",
    transform: "translate(-69.078 -8.948)",
    fill: "#f78f01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_144",
    "data-name": "Caminho 144",
    d: "M73.445,14.325,71.69,13.093V12.71l2.3,1.615Z",
    transform: "translate(-69.078 -9.125)",
    fill: "#f78e01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_145",
    "data-name": "Caminho 145",
    d: "M72.9,14.5l-1.211-.848V13.27L73.445,14.5Z",
    transform: "translate(-69.078 -9.302)",
    fill: "#f78d01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_146",
    "data-name": "Caminho 146",
    d: "M72.364,14.678l-.674-.472V13.83l1.211.848Z",
    transform: "translate(-69.078 -9.479)",
    fill: "#f78c01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_147",
    "data-name": "Caminho 147",
    d: "M71.819,14.852l-.129-.089V14.38l.674.472Z",
    transform: "translate(-69.078 -9.653)",
    fill: "#f68b01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_148",
    "data-name": "Caminho 148",
    d: "M71.69,14.94l.129.089H71.69Z",
    transform: "translate(-69.078 -9.829)",
    fill: "#f68a01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_149",
    "data-name": "Caminho 149",
    d: "M94.2,10.083,90.51,7.49H94.2Z",
    transform: "translate(-75.094 -7.476)",
    fill: "#feb002",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_150",
    "data-name": "Caminho 150",
    d: "M93.942,10.466,89.71,7.49h.544l3.687,2.593Z",
    transform: "translate(-74.838 -7.476)",
    fill: "#feb002",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M93.689,10.849,88.92,7.49h.537l4.232,2.976Z",
    transform: "translate(-74.586 -7.476)",
    fill: "#feaf02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_152",
    "data-name": "Caminho 152",
    d: "M93.433,11.225,88.12,7.49h.544l4.769,3.359Z",
    transform: "translate(-74.33 -7.476)",
    fill: "#feae02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_153",
    "data-name": "Caminho 153",
    d: "M93.181,11.609,87.33,7.49h.537l5.313,3.735Z",
    transform: "translate(-74.078 -7.476)",
    fill: "#fdad02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_154",
    "data-name": "Caminho 154",
    d: "M92.925,11.992,86.53,7.49h.544l5.851,4.119Z",
    transform: "translate(-73.822 -7.476)",
    fill: "#fdac02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_155",
    "data-name": "Caminho 155",
    d: "M92.669,12.375,85.73,7.49h.544l6.395,4.5Z",
    transform: "translate(-73.566 -7.476)",
    fill: "#fdab02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_156",
    "data-name": "Caminho 156",
    d: "M92.417,12.751,84.94,7.49h.537l6.939,4.885Z",
    transform: "translate(-73.314 -7.476)",
    fill: "#fdaa02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_157",
    "data-name": "Caminho 157",
    d: "M92.161,13.134,84.14,7.49h.544l7.477,5.261Z",
    transform: "translate(-73.058 -7.476)",
    fill: "#fda902",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_158",
    "data-name": "Caminho 158",
    d: "M91.905,13.517,83.34,7.49h.544l8.021,5.644Z",
    transform: "translate(-72.802 -7.476)",
    fill: "#fca802",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_159",
    "data-name": "Caminho 159",
    d: "M91.653,13.9l-9.1-6.41h.537l8.565,6.027Z",
    transform: "translate(-72.549 -7.476)",
    fill: "#fca702",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    "data-name": "Caminho 160",
    d: "M91.4,14.284,81.75,7.49h.544l9.1,6.41Z",
    transform: "translate(-72.294 -7.476)",
    fill: "#fca602",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_161",
    "data-name": "Caminho 161",
    d: "M91.141,14.66,80.95,7.49h.544l9.647,6.794Z",
    transform: "translate(-72.038 -7.476)",
    fill: "#fca502",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    "data-name": "Caminho 162",
    d: "M90.888,15.043,80.16,7.49H80.7l10.191,7.17Z",
    transform: "translate(-71.785 -7.476)",
    fill: "#fba402",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    "data-name": "Caminho 163",
    d: "M90.483,15.317,79.36,7.49H79.9l10.728,7.553v.274Z",
    transform: "translate(-71.53 -7.476)",
    fill: "#fba302",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_164",
    "data-name": "Caminho 164",
    d: "M89.686,15.317,78.57,7.49h.537L90.23,15.317Z",
    transform: "translate(-71.277 -7.476)",
    fill: "#fba202",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_165",
    "data-name": "Caminho 165",
    d: "M88.886,15.317,77.77,7.49h.544L89.43,15.317Z",
    transform: "translate(-71.021 -7.476)",
    fill: "#fba102",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_166",
    "data-name": "Caminho 166",
    d: "M88.093,15.317,76.97,7.49h.544L88.63,15.317Z",
    transform: "translate(-70.766 -7.476)",
    fill: "#fba002",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_167",
    "data-name": "Caminho 167",
    d: "M87.3,15.317,76.18,7.49h.537L87.84,15.317Z",
    transform: "translate(-70.513 -7.476)",
    fill: "#fa9f02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_168",
    "data-name": "Caminho 168",
    d: "M86.5,15.317,75.38,7.49h.544L87.04,15.317Z",
    transform: "translate(-70.257 -7.476)",
    fill: "#fa9e02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_169",
    "data-name": "Caminho 169",
    d: "M85.7,15.317,74.58,7.49h.544l11.123,7.827Z",
    transform: "translate(-70.002 -7.476)",
    fill: "#fa9d02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_170",
    "data-name": "Caminho 170",
    d: "M84.906,15.317,73.79,7.49h.537L85.45,15.317Z",
    transform: "translate(-69.749 -7.476)",
    fill: "#fa9c02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_171",
    "data-name": "Caminho 171",
    d: "M84.113,15.317,72.99,7.49h.544L84.65,15.317Z",
    transform: "translate(-69.493 -7.476)",
    fill: "#fa9b02",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_172",
    "data-name": "Caminho 172",
    d: "M83.313,15.317,72.19,7.49h.544l11.123,7.827Z",
    transform: "translate(-69.237 -7.476)",
    fill: "#f99901",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_173",
    "data-name": "Caminho 173",
    d: "M82.516,15.317,71.4,7.49h.537L83.06,15.317Z",
    transform: "translate(-68.985 -7.476)",
    fill: "#f99801",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_174",
    "data-name": "Caminho 174",
    d: "M81.723,15.317,70.6,7.49h.544L82.26,15.317Z",
    transform: "translate(-68.729 -7.476)",
    fill: "#f99701",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_175",
    "data-name": "Caminho 175",
    d: "M80.926,15.317,69.81,7.49h.537L81.47,15.317Z",
    transform: "translate(-68.477 -7.476)",
    fill: "#f99601",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_176",
    "data-name": "Caminho 176",
    d: "M80.126,15.317,69.01,7.49h.544L80.67,15.317Z",
    transform: "translate(-68.221 -7.476)",
    fill: "#f99501",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_177",
    "data-name": "Caminho 177",
    d: "M79.333,15.317,68.21,7.49h.544L79.87,15.317Z",
    transform: "translate(-67.965 -7.476)",
    fill: "#f89401",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_178",
    "data-name": "Caminho 178",
    d: "M78.677,15.317,67.86,7.7V7.49H68.1l11.123,7.827Z",
    transform: "translate(-67.853 -7.476)",
    fill: "#f89301",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_179",
    "data-name": "Caminho 179",
    d: "M78.139,15.415,67.86,8.183V7.8l10.817,7.615Z",
    transform: "translate(-67.853 -7.574)",
    fill: "#f89201",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_180",
    "data-name": "Caminho 180",
    d: "M77.6,15.591,67.86,8.743V8.36l10.279,7.231Z",
    transform: "translate(-67.853 -7.751)",
    fill: "#f89101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_181",
    "data-name": "Caminho 181",
    d: "M77.051,15.768,67.86,9.3V8.92L77.6,15.768Z",
    transform: "translate(-67.853 -7.928)",
    fill: "#f89001",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_182",
    "data-name": "Caminho 182",
    d: "M76.514,15.942,67.86,9.853V9.47l9.191,6.472Z",
    transform: "translate(-67.853 -8.102)",
    fill: "#f78f01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_183",
    "data-name": "Caminho 183",
    d: "M75.969,16.119,67.86,10.413V10.03l8.654,6.089Z",
    transform: "translate(-67.853 -8.279)",
    fill: "#f78e01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_184",
    "data-name": "Caminho 184",
    d: "M75.425,16.3,67.86,10.973V10.59L75.969,16.3Z",
    transform: "translate(-67.853 -8.455)",
    fill: "#f78d01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_185",
    "data-name": "Caminho 185",
    d: "M74.888,16.473,67.86,11.526V11.15l7.565,5.323Z",
    transform: "translate(-67.853 -8.632)",
    fill: "#f78c01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_186",
    "data-name": "Caminho 186",
    d: "M74.343,16.646,67.86,12.083V11.7l7.028,4.946Z",
    transform: "translate(-67.853 -8.806)",
    fill: "#f68b01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_187",
    "data-name": "Caminho 187",
    d: "M73.8,16.823l-5.939-4.18V12.26l6.483,4.563Z",
    transform: "translate(-67.853 -8.983)",
    fill: "#f68a01",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_188",
    "data-name": "Caminho 188",
    d: "M73.262,17l-5.4-3.8V12.82L73.8,17Z",
    transform: "translate(-67.853 -9.16)",
    fill: "#f68901",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_189",
    "data-name": "Caminho 189",
    d: "M72.717,17.177,67.86,13.756V13.38l5.4,3.8Z",
    transform: "translate(-67.853 -9.337)",
    fill: "#f68801",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_190",
    "data-name": "Caminho 190",
    d: "M72.18,17.351l-4.32-3.038V13.93l4.857,3.421Z",
    transform: "translate(-67.853 -9.51)",
    fill: "#f68701",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_191",
    "data-name": "Caminho 191",
    d: "M71.636,17.528,67.86,14.873V14.49l4.32,3.038Z",
    transform: "translate(-67.853 -9.687)",
    fill: "#f58601",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_192",
    "data-name": "Caminho 192",
    d: "M71.091,17.7,67.86,15.433V15.05L71.636,17.7Z",
    transform: "translate(-67.853 -9.864)",
    fill: "#f58501",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_193",
    "data-name": "Caminho 193",
    d: "M70.554,17.881,67.86,15.993V15.61l3.231,2.271Z",
    transform: "translate(-67.853 -10.041)",
    fill: "#f58401",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_194",
    "data-name": "Caminho 194",
    d: "M67.86,16.17l2.694,1.888H67.86Z",
    transform: "translate(-67.853 -10.218)",
    fill: "#f58401",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_603",
    "data-name": "Grupo 603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_196",
    "data-name": "Caminho 196",
    d: "M4.136,7.19H4.8a1.493,1.493,0,0,0,1.32-.575l4.021-5.8a1.668,1.668,0,0,1,.755-.643A2.705,2.705,0,0,1,11.926,0h3.6L10.239,7.177a3.608,3.608,0,0,1-.585.643,3.485,3.485,0,0,1-.626.424,3.046,3.046,0,0,1,.85.472,3.011,3.011,0,0,1,.7.8l5.388,8.237H12.273a3.057,3.057,0,0,1-.605-.048,1.714,1.714,0,0,1-.435-.144,1.122,1.122,0,0,1-.32-.239A2.529,2.529,0,0,1,10.654,17L6.613,10.823a1.208,1.208,0,0,0-.558-.479,2.393,2.393,0,0,0-.912-.137H4.136v7.553H0V0H4.136Z",
    transform: "translate(0 0.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_197",
    "data-name": "Caminho 197",
    d: "M37.174,0V3.168h-7.32V7.314h5.606v3.044H29.853v4.228h7.32v3.168H25.69V0Z",
    transform: "translate(-8.213 0.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_198",
    "data-name": "Caminho 198",
    d: "M54.109,11v6.753H49.973V11L43.51,0h3.646a1.321,1.321,0,0,1,.857.253,1.912,1.912,0,0,1,.517.636l2.524,5.165c.2.417.395.794.565,1.143s.32.691.456,1.033a9.818,9.818,0,0,1,.442-1.047c.17-.349.354-.725.551-1.136l2.5-5.165a1.373,1.373,0,0,1,.2-.315,2.333,2.333,0,0,1,.293-.287,1.358,1.358,0,0,1,.381-.205,1.468,1.468,0,0,1,.469-.082h3.674l-6.463,11Z",
    transform: "translate(-13.91 0.01)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeydriveLogoAdmin);
export default __webpack_public_path__ + "static/media/keydrive_logo_admin.7c1871d305cea8c5526146b2a70d622c.svg";
export { ForwardRef as ReactComponent };